import { createReduxAsyncThunk } from 'shared/utils';

import { carsAPI } from '../../api';

import { CARS_STATE } from '../../constants';

import { CarsLocationSharing } from '../../types';

export const deleteCarLocationSharing = createReduxAsyncThunk(
  `${CARS_STATE}/deleteCarLocationSharing`,
  async (id: CarsLocationSharing['id']) => {
    const { data } = await carsAPI.deleteCarLocationSharing(id);
    return data;
  }
);
